const CAP19 = {
  "id": 42,
  "title": "Los UTXO",
  "slug": "como-enviar-bitcoin-y-utxo",
  "type": "lesson",
  "category": "bitcoin",
  "level": "basic",
  "sections": [
    {
      "heading": "Introducción: enviar Bitcoin y cómo funciona realmente",
      "text": [
        "Enviar Bitcoin parece tan simple como escribir una dirección y elegir una cantidad, pero detrás de esa acción ocurre un proceso técnico basado en el modelo UTXO.",
        "Bitcoin no utiliza cuentas bancarias tradicionales, sino que funciona mediante salidas de transacciones no gastadas, conocidas como UTXO (Unspent Transaction Outputs).",
        "Comprender los UTXO ayuda a entender qué está pasando cuando envías Bitcoin y por qué recibes cambio, pagas comisiones o ves movimientos con cantidades extrañas."
      ]
    },
    {
      "heading": "¿Qué necesitas para enviar Bitcoin?",
      "list": [
        "Saldo disponible en tu wallet (representado como UTXOs).",
        "Una dirección pública de destino.",
        "Conexión a Internet para transmitir la transacción.",
        "Confirmación mediante clave privada o firma digital."
      ]
    },
    {
      "heading": "Direcciones y claves para autorizar el envío",
      "text": [
        "Para enviar Bitcoin se utilizan direcciones públicas (parecidas a cuentas) y claves privadas (como una firma o contraseña criptográfica).",
        "La clave privada nunca se comparte. Es la que autoriza y firma la transacción.",
        "Sin la clave privada, no se pueden mover los fondos."
      ]
    },
    {
      "heading": "¿Qué es un UTXO?",
      "text": [
        "UTXO significa Unspent Transaction Output o Salida de Transacción No Gastada.",
        "Cada vez que recibes Bitcoin, lo que realmente llega a tu wallet es uno o varios UTXO.",
        "Un UTXO es como un billete digital: tiene un valor específico, no se puede dividir y se gasta entero al hacer una transacción.",
        "Cuando gastas un UTXO, se genera:",
        "- Una nueva salida hacia el destinatario.",
        "- Y otra salida con el cambio que vuelve a ti."
      ],
    
    },
    {
      "heading": "¿Cómo se construye una transacción en Bitcoin?",
      "text": [
        "Cuando envías Bitcoin, la wallet hace lo siguiente:",
        "1. Selecciona los UTXOs necesarios para cubrir el monto que deseas enviar.",
        "2. Agrupa esos UTXOs y los gasta en una nueva transacción.",
        "3. Crea nuevas salidas: una para el destinatario, otra opcional como cambio.",
        "4. Agrega la comisión (fee) para los mineros.",
        "5. Firma todo con tu clave privada y lo envía a la red."
      ]
    },
    {
      "heading": "Ejemplo de envío usando UTXO",
      "text": [
        "Imagina que tienes los siguientes UTXOs en tu wallet:",
        "• 0.015 BTC\n• 0.005 BTC\n• 0.020 BTC",
        "Quieres enviar 0.018 BTC a otra persona.",
        "La wallet podría usar los UTXOs de 0.015 BTC y 0.005 BTC (0.020 BTC en total).",
        "Se gastan completamente y se generan dos salidas:",
        "• 0.018 BTC → Destinatario\n• 0.0015 BTC → Cambio (menos la comisión)"
      ]
    },
    {
      "heading": "Comisiones (fees) en las transacciones",
      "text": [
        "La comisión no depende de la cantidad enviada (como en los bancos), sino del tamaño de la transacción en bytes.",
        "Una transacción con muchos UTXOs es más grande y paga más fee.",
        "Por eso, las wallets permiten elegir entre envío económico, estándar o rápido (alta prioridad)."
      ]
    },
    {
      "heading": "Confirmaciones en la red",
      "text": [
        "Cuando envías Bitcoin, la transacción se transmite a los nodos y espera a ser incluida en un bloque.",
        "Cada vez que un nuevo bloque la incorpora, se considera una confirmación.",
        "Según el servicio, se puede requerir 1, 3 o más confirmaciones para disponer de los fondos."
      ]
    },
    {
      "heading": "Ventajas del envío mediante Bitcoin",
      "list": [
        "Disponible 24/7 en cualquier parte del mundo.",
        "Irreversible una vez confirmada.",
        "Seguridad basada en criptografía y consenso.",
        "Sin bancos ni intermediarios.",
        "Comisiones bajas, incluso internacionales.",
        "Puedes enviar fracciones muy pequeñas gracias a los satoshis."
      ]
    }
  ]
};

export default CAP19;
